module.exports = __webpack_public_path__ + "assets/img/background_color_of_content.d324312.jpeg";


//////////////////
// WEBPACK FOOTER
// ./website/assets/background_color_of_content.jpeg
// module id = zfo0
// module chunks = 50